export default function configureSearch() {
  let script = document.createElement('script'),
    init = function () {
      script.type = 'text/javascript';
      script.src = '//search.usa.gov/javascripts/remote.loader.js';
      document.getElementsByTagName('head')[0].appendChild(script);

      $('.header-main-search-toggle-label').on('click', function (e) {
        if (
          !$('#header-main-search-state').prop('checked') &&
          //no focus for old ie since it loses the placeholder text
          window.navigator.userAgent.match(/MSIE|Trident/) === null
        ) {
          $('#header-main-search input[type=search]')[0].focus();
        }
      });

      $('.header-main-search-toggle-label').on('keypress', function (e) {
        let keycode = e.keyCode || e.charCode || e.which; //for cross browser

        if (!$('#header-main-search-state').prop('checked') && (keycode == 13 || keycode == 32)) {
          $('#header-main-search-state').prop('checked', true);
          $('#header-main-search input[type=search]')[0].focus();
          return;
        }

        if ($('#header-main-search-state').prop('checked') && (keycode == 13 || keycode == 32)) {
          $('#header-main-search-state').prop('checked', false);
          closeAndCleanupSearch();
          return;
        }

      });

      $('#header-main-search input[type=search], #nav-main-search input[type=search]').on('keypress', function (e) {
        let keycode = e.keyCode || e.charCode || e.which; //for cross browser

        if (keycode == 13) {
          //keyCode for enter key
          submitSearch($(this));
          e.stopImmediatePropagation();
          return false;
        }
      });

      $(window).on('resize scroll', function () {
        closeAndCleanupSearch();
      });
      $('#main-search-open-overlay').on('click', function (e) {
        e.stopPropagation();
        closeAndCleanupSearch();
      });
    },
    closeAndCleanupSearch = function () {
      $('#header-main-search-state').prop('checked', false).trigger('change');
    },
    submitSearch = function ($this) {
      const query = $this ? $this.val() || $this.parent().find('input').val() : '';
      const affiliate = skinvars.aid;
      window.location = '//search.usa.gov/search?query=' + DOMPurify.sanitize(query) + '&affiliate=' + affiliate + '&utf8=%26%23x2713%3B';
    };

  init();
}

window.usasearch_config = {
  siteHandle: skinvars.aid,
  autoSubmitOnSelect: false,
};
